import { useState, createContext, useContext } from "react";
const MenuContext = createContext();
const TitleContext = createContext();
const PathContext = createContext();
const CopyContext = createContext();


export { MenuContext, TitleContext, PathContext, CopyContext };